export const members = [
  {
    slug: 'jurai',
    name: 'Jurai',
    role: 'Gesang',
    bio: 'Jurai bringt eine der Lead-Vocal-Perspektiven von Tuesday auf die Bühne und prägt den emotionalen und melodischen Charakter der Sets.',
    quote:
      'Musik ist für mich die direkteste Verbindung zum Publikum. Jeder Song erzählt eine neue Geschichte.',
    imagePlaceholder: 'J',
    imageLight:
      'https://cdn.magicpatterns.com/uploads/2k82UnXXKLX7bsKno12sHg/Jurai_Light.png',
    imageDark:
      'https://cdn.magicpatterns.com/uploads/jGFQHhGC4UYtuG1uXzZXg7/Jurai_Dark.png',
  },
  {
    slug: 'max',
    name: 'Max',
    role: 'Gesang',
    bio: 'Max ergänzt Tuesday mit einer zweiten Gesangsstimme und hilft der Band, zwischen verschiedenen Songs, Stimmungen und Live-Arrangements zu wechseln.',
    quote:
      'Die Dynamik zwischen zwei Stimmen gibt uns die Freiheit, jedem Cover unseren eigenen Stempel aufzudrücken.',
    imagePlaceholder: 'M',
    imageLight:
      'https://cdn.magicpatterns.com/uploads/wY5F1uYveFnpVQdyz94Jye/Max_Light.png',
    imageDark:
      'https://cdn.magicpatterns.com/uploads/7yHpuKs7vUsBAR8SpPnySe/Max_Dark.png',
  },
  {
    slug: 'leon',
    name: 'Leon',
    role: 'E-Gitarre',
    bio: 'Leon treibt den Gitarrensound von Tuesday voran, von rhythmischen Grundlagen über melodische Akzente bis hin zu energiegeladenen Live-Momenten.',
    quote:
      'Ein gutes Riff ist wie ein Anker im Song. Es hält alles zusammen und treibt gleichzeitig nach vorne.',
    imagePlaceholder: 'L',
    imageLight:
      'https://cdn.magicpatterns.com/uploads/7ZfxiVtNCgroyd6yo4J4qY/Leon_Light.png',
    imageDark:
      'https://cdn.magicpatterns.com/uploads/mTXEmqDaCVCe6UEgHJYrgg/Leon_Dark.png',
  },
  {
    slug: 'laura',
    name: 'Laura',
    role: 'E-Bass',
    bio: 'Laura spielt das Fundament von Tuesday und verbindet Groove, Harmonie und Bewegung durch das gesamte Set.',
    quote:
      'Der Bass ist der Herzschlag der Band. Wenn der Groove stimmt, bewegt sich der ganze Raum.',
    imagePlaceholder: 'L',
    imageLight:
      'https://cdn.magicpatterns.com/uploads/4SHbKWTe5iv8L1mpyD8Vat/Laura_Light.png',
    imageDark:
      'https://cdn.magicpatterns.com/uploads/n3CdbNw6w35Mob5qH3t3vK/Laura_Dark.png',
  },
]
